import { render, staticRenderFns } from "./Workflow-Application.vue?vue&type=template&id=498a18ee&"
import script from "./Workflow-Application.vue?vue&type=script&lang=js&"
export * from "./Workflow-Application.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports